import { render, staticRenderFns } from "./OrderDocs.vue?vue&type=template&id=0defbd80&scoped=true&"
import script from "./OrderDocs.vue?vue&type=script&lang=js&"
export * from "./OrderDocs.vue?vue&type=script&lang=js&"
import style0 from "./OrderDocs.vue?vue&type=style&index=0&id=0defbd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0defbd80",
  null
  
)

export default component.exports